import { isEmpty } from 'remeda'
import { SansText } from '../SansText/SansText'
import { StyledButton } from './Button.styles'
import type { ButtonProps } from './Button.types'

export const Button = (props: ButtonProps): JSX.Element => {
  const { text, Icon, dataTestId, ...rest } = props

  return (
    <StyledButton {...rest} data-testid={dataTestId}>
      {Icon && <Icon width="14" height="14" />}
      {!isEmpty(text) && (
        <SansText uppercase fontWeight="500" as="span" color="inherit">
          {text}
        </SansText>
      )}
    </StyledButton>
  )
}
